<template>
  <div>
    <div class="flex justify-between items-center my-8">
      <b-modal
        modal-content-classes="cust-modal-ht"
        header-bg-variant="primary"
        header-text-variant="white"
        id="edit-donor"
        title="Edit Donor"
        hide-footer
      >
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <b-form role="form" @submit.prevent="handleSubmit(handleUpdate)">
            <div class="mt-4">
              <FileUploader
                v-show="!image"
                :image="image"
                :onSuccess="handleSuccess"
                accept="image"
                class="rounded-full widtht30percent m-auto display-none custmodal"
              />
              <img
                v-if="image"
                :src="
                  image.slice(0, 4) === 'data' ? image : `${$imageURL}/${image}`
                "
                ref="cover"
                class="rounded-full widtht30percent m-auto display-none custmodal"
              />
              <div
                class="text-center text-red"
                v-if="image"
                @click="handleRemove"
              >
                Remove image
              </div>
              <p class="text-center">Upload your cover photo</p>
              <span v-if="imageErr" class="small text-danger">{{
                msg.image
              }}</span>
            </div>
            <div class="mb-4">
              <p class="input-title text-black">Name</p>
              <base-input
                v-model="name"
                placeholder="Enter donor name"
                class="md:border-0 lg:border-0 custipshadow"
                name="Title"
                :rules="{ required: true }"
              ></base-input>
            </div>
            <div class="mb-4">
              <p class="input-title text-black">Type</p>
              <b-form-select
                v-model="type"
                placeholder="Select"
                class="w-full"
                required
              >
                <b-form-select-option
                  v-for="item in typeOptions"
                  class="py-5"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </b-form-select-option>
              </b-form-select>
            </div>
            <div class="mb-4">
              <p class="input-title text-black">Page to show Donor</p>
              <b-form-select
                v-model="category"
                placeholder="Select"
                class="w-full"
                required
              >
                <b-form-select-option
                  v-for="item in pageOptions"
                  class="py-5"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </b-form-select-option>
              </b-form-select>
            </div>
            <div class="mb-4">
              <p class="input-title text-black">Plan</p>
              <b-form-select
                v-model="plan"
                placeholder="Select"
                class="w-full"
                required
              >
                <template v-if="type == '' || type == 'individual'">
                  <b-form-select-option
                    v-for="item in planOptions1"
                    class="py-5"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </b-form-select-option>
                </template>
                <template v-if="type == 'corporate'">
                  <b-form-select-option
                    v-for="item in planOptions2"
                    class="py-5"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </b-form-select-option>
                </template>
              </b-form-select>
            </div>
            <div class="flex justify-center">
              <b-button
                class="font-semibold"
                type="primary"
                native-type="submit"
                variant="primary"
                >Update</b-button
              >
              <b-button
                class="font-semibold"
                variant="primary"
                @click="closeModal('edit-donor')"
                >Close</b-button
              >
            </div>
          </b-form>
        </validation-observer>
      </b-modal>
      <div class="flex justify-between">
        <div class="flex">
          <base-button outline type="primary" class="flex px-3 py-1 mx-1">
            <download-excel
              class="mr-1 flex"
              default-value=""
              :fetch="fetchSelected"
              :fields="json_fields"
              worksheet="My Worksheet"
              name="GetAppUserData.xls"
            >
              <feather-icon
                icon="UploadIcon"
                class="mr-2 cust-HW"
              ></feather-icon
              >Export Selected
            </download-excel>
          </base-button>
          <base-button outline type="primary" class="flex px-3 py-1 mx-1">
            <download-excel
              class="mr-1 flex"
              default-value=""
              :fetch="fetchData"
              :fields="json_fields"
              worksheet="My Worksheet"
              name="GetAppUserData.xls"
            >
              <feather-icon
                icon="UploadIcon"
                class="mr-2 cust-HW"
              ></feather-icon
              >Export All
            </download-excel>
          </base-button>
        </div>
      </div>
    </div>
    <div class="flex gap-4">
      <div class="w-full">
        <b-input-group class="">
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            v-model="search"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
              @click=""
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
    <div class="flex justify-end my-5">
      <base-button
        outline
        type="primary"
        class="flex px-3 py-1 mx-1"
        @click="getList('corporate')"
      >
        Corporate
      </base-button>
      <base-button
        outline
        type="primary"
        class="flex px-3 py-1 mx-1"
        @click="getList('individual')"
      >
        Individual
      </base-button>
      <base-button
        outline
        type="primary"
        class="flex px-3 py-1 mx-1"
        @click="
          filterType = 'all';
          search = '';
          getDonorList();
        "
      >
        Clear filter
      </base-button>
    </div>
    <el-table
      border
      :data="getDonors.result"
      style="width: 100%"
      class="mt-4 rounded"
      header-row-class-name="thead-light table-th-color "
      @selection-change="selectedRow"
    >
      <el-table-column type="selection" width="50px"> </el-table-column>

      <el-table-column prop="name" label="Name" v-slot="{ row }">
        {{ row.name }}
      </el-table-column>
      <el-table-column prop="type" label="Type" v-slot="{ row }">
        {{ row.type.toUpperCase() }}
      </el-table-column>
      <el-table-column prop="plan" label="Plan" v-slot="{ row }">
        {{ row.plan }}
      </el-table-column>

      <el-table-column
        label="Created On"
        prop="editedby"
        min-width="130px"
        v-slot="{ row }"
      >
        {{ new Date(row.createdAt).toDateString() }}
      </el-table-column>
      <el-table-column
        label="Actions"
        min-width="80px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <div class="flex">
              <feather-icon
                icon="Edit2Icon"
                svgClasses="w-4 text-blue-600 cursor-pointer"
                class="ml-2"
                @click="handleEdit(scope.row)"
              ></feather-icon>
            </div>

            <div class="flex" @click="handleDelete(scope.row._id)">
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 text-red-600 cursor-pointer"
                class="ml-2"
              ></feather-icon>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        @change="handlePageChange"
      ></b-pagination>
    </b-card-footer>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import _ from "lodash";
import { mapState } from "vuex";
import FileUploader from "../../../../../components/FileUploader.vue";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    FileUploader,
  },
  data() {
    return {
      search: "",
      totalRows: 0,
      meditationId: "",
      perPage: 10,
      currentPage: 1,
      selectedData: [],
      name: "",
      plan: "",
      type: "",
      editId: "",
      category: "",
      image: null,
      coverImage: null,
      imageErr: false,
      audioErr: false,
      msg: {
        image: "",
        audio: "",
      },
      pageOptions: [
        { name: "Donation Page", value: "Donation Page" },
        { name: "FOCGS Page", value: "FOCGS Page" },
      ],
      typeOptions: [
        { name: "Individual", value: "individual" },
        { name: "Corporate", value: "corporate" },
      ],
      planOptions1: [
        { name: "Caregiver Champion", value: "Caregiver Champion" },
        { name: "Angel of Care", value: "Angel of Care" },
        { name: "Compassion Supporter", value: "Compassion Supporter" },
      ],
      planOptions2: [
        {
          name: "Corporate Compassion Partner",
          value: "Corporate Compassion Partner",
        },
        {
          name: "Caregiver's Champion Partner",
          value: "Caregiver's Champion Partner",
        },
        { name: "CSR Caregiver Advocate", value: "CSR Caregiver Advocate" },
      ],
      filterType: "all",
    };
  },
  methods: {
    async fetchSelected() {
      if (this.selectedData.length === 0) {
        return this.$swal({
          title: "No Selection!",
          html: `<p class="text-center">Please select rows to be exported!</p>`,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
      }
      let loader = this.$loading();
      try {
        loader.close();
        this.$swal({
          html: `<p class="text-center">Data has been successfully exported!</p>`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
        return this.selectedData;
      } catch (error) {
        loader.close();
      }
    },
    async fetchData() {
      let payload = {
        // limit: this.total_row,
        type: this.filterType,
      };

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("services/getDonor", payload);
        // console.log(data, "///");
        if (data.code == 200) {
          loader.close();
          this.$swal({
            html: `<p class="text-center">Data has been successfully exported!</p>`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          return data.data[0].result;
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    closeModal(name) {
      this.$bvModal.hide(name);
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handlePageChange(value) {
      try {
        this.currentPage = value;
        this.getDonorList();
      } catch (error) {
        console.log(error);
      }
    },

    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData(id) {
      let loader;
      let payload = {
        _id: id,
      };
      loader = this.$loading();
      try {
        const data = await this.$store.dispatch(
          "services/deleteDonor",
          payload
        );
        loader.close();
        if (data.code === 200) {
          this.getDonorList();
          await this.$swal({
            text: "Deleted successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
      } catch (err) {
        loader.close();
        console.log(err);
      }
    },

    handleEdit(data) {
      this.name = data.name;
      this.plan = data.plan;
      this.type = data.type;
      this.editId = data._id;
      this.category = data.category;
      this.image = data.image != "null" ? data.image : "";
      this.$bvModal.show("edit-donor");
    },
    async handleUpdate() {
      // if (this.coverImage === null) {
      //   await this.$swal({
      //     text: "Please upload cover photo!",
      //     icon: "warning",
      //     showCancelButton: false,
      //     confirmButtonColor: "#830c81",
      //   });
      //   return;
      // }
      const payload = new FormData();
      payload.append("name", this.name);
      payload.append("plan", this.plan);
      payload.append("type", this.type);
      payload.append("category", this.category);
      payload.append("image", this.coverImage);
      payload.append("_id", this.editId);
      let loader;
      try {
        loader = this.$loading();
        let data = await this.$store.dispatch("services/updateDonor", payload);
        if (data.code == 200) {
          this.$swal.fire({
            text: " Successfully  Edited",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        this.getDonorList();
        this.$bvModal.hide("edit-donor");
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    getList(name) {
      this.filterType = name;
      this.getDonorList();
    },
    async getDonorList() {
      let loader;
      let payload = {
        search: this.search,
        offset: this.currentPage - 1,
        limit: 10,
        type: this.filterType,
      };
      try {
        loader = this.$loading();
        await this.$store.dispatch("services/getDonor", payload);
        this.totalRows = this.getDonors.totalCount;
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    selectedRow(val) {
      this.selectedData = val;
    },
  },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        this.getDonorList();
      }, 500),
    },
  },
  computed: {
    ...mapState("services", {
      getDonors: "getDonors",
    }),
    json_fields() {
      return {
        Name: "name",
        Type: "type",
        Plan: "plan",
        created_at: {
          field: "createdAt",
          callback: (date) => {
            return new Date(date).toDateString();
          },
        },
      };
    },
  },
  async mounted() {
    this.getDonorList();
  },
};
</script>

<style>
.width100 {
  width: 100px;
  height: 100px !important;
}
</style>
